import { css } from "emotion";

export const CheckBoxContainer = css`
	color: grey;
	font-family: BPGNinoMtavruli;
	text-align: left;
`;
